import { TabContext, TabList } from '@mui/lab';
import { Box, Tab, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { SyntheticEvent, useState } from 'react';
import AlertsPanel from './alerts-panel';

const Container = styled(Box)({
  height: '100%',
  backgroundColor: '#fff'
});

const Title = styled(Typography)({
  marginLeft: 16,
  marginBottom: 12,
  fontSize: 24,
  fontWeight: 500,
  lineHeight: '28px',
  color: '#000'
});

const StyledTabList = styled(TabList)({
  borderTop: '1px solid #E1E4E7',
  borderBottom: '1px solid #E1E4E7'
});

const StyledTab = styled(Tab)({
  textTransform: 'none'
});

export default function AlertsWidget() {
  const [value, setValue] = useState<'active' | 'dismissed'>('active');

  const handleChange = (event: SyntheticEvent, newValue: 'active' | 'dismissed') => {
    setValue(newValue);
  };

  return (
    <Container>
      <Title variant='h3'>Alerts</Title>
      <TabContext value={value}>
        <StyledTabList variant='fullWidth' onChange={handleChange}>
          <StyledTab label='Active' value='active' />
          <StyledTab label='Dismissed' value='dismissed' />
        </StyledTabList>
        <AlertsPanel type='active' />
        <AlertsPanel type='dismissed' />
      </TabContext>
    </Container>
  );
}
